module.exports = __webpack_public_path__ + "static/img/yangluo.0d8f2e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/yangluo.png
// module id = zYlp
// module chunks = 44